var map = {
	"./Asscher.png": 783,
	"./Asscher@2x.png": 318,
	"./Cushion.png": 784,
	"./Cushion@2x.png": 319,
	"./Emerald.png": 785,
	"./Emerald@2x.png": 320,
	"./Faceted Trapezoid.png": 786,
	"./Faceted Trapezoid@2x.png": 321,
	"./Half Moon.png": 787,
	"./Half Moon@2x.png": 322,
	"./Heart.png": 788,
	"./Heart@2x.png": 323,
	"./Marquise.png": 789,
	"./Marquise@2x.png": 324,
	"./Oval.png": 790,
	"./Oval@2x.png": 325,
	"./Pear.png": 791,
	"./Pear@2x.png": 326,
	"./Princess.png": 792,
	"./Princess@2x.png": 327,
	"./Radiant.png": 793,
	"./Radiant@2x.png": 328,
	"./Round.png": 794,
	"./Round@2x.png": 329,
	"./Step Cut Trapezoid.png": 795,
	"./Step Cut Trapezoid@2x.png": 330,
	"./Straight Baguette.png": 796,
	"./Straight Baguette@2x.png": 331,
	"./Tapered Baguette.png": 797,
	"./Tapered Baguette@2x.png": 332,
	"./Triangle.png": 798,
	"./Triangle@2x.png": 333,
	"./Trilliant.png": 799,
	"./Trilliant@2x.png": 334
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;



//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images ^\.\/.*\.png$
// module id = 507
// module chunks = 0